export default "__VITE_ASSET__3ab9be46__"